// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"2145e926","612":"2145e926"}[chunkId] + ".css";
};